<template>
  <Breadcrumb class="bread">
    <BreadcrumbItem v-for="(item, index) in breadList" :key="index" :to="{ path: item.path }">{{ item.meta.title }}
    </BreadcrumbItem>
  </Breadcrumb>
</template>
<script>
export default {
  data() {
    return {
      isShow: true,
      breadList: [], // 路由集合
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    isHome(route) {
      return route.name === "home";
    },
    getBreadcrumb() {
      let matched = this.$route.matched;
      //如果不是首页
      if (!this.isHome(matched[0])) {
        this.isShow = false;
        matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);

      } else {
        this.isShow = true;
      }
      let filterMatched = matched.filter((el) => {
        return el.name !== "index";
      });
      this.breadList = filterMatched;
    },
  },
  created() {
    this.getBreadcrumb();
  },
};
</script>
<style lang="less">
@import '../styles/base/_variables.less';


.bread {
  padding: 10px 0;
  max-width: 1400px;
  margin: auto;

  @media (max-width: @screen-sm) {
    padding: 0 0;
    display: none;
  }

  @media (min-width: @screen-sm) {
    padding: 15px 0;
    font-size: @font-size-lg;

    .ivu-breadcrumb-item-separator {
      margin: 0 8px;
    }

    .ivu-breadcrumb-item-link {
      font-size: @font-size-base;
      transition: color 0.3s;

      &:hover {
        color: @primary-color;
      }
    }
  }
}
</style>
